import { ActionType, ActionTypes } from './index';

export function showFatalError() {
    return {
        type: ActionTypes.SHOW_FATAL_ERROR
    };
}

export function hideFatalError() {
    return {
        type: ActionTypes.HIDE_FATAL_ERROR
    };
}

